import { useQueryStates, parseAsString } from 'nuqs'

export const useDayforceBookingsFiltersQueryState = () => {
  return useQueryStates(
    {
      searchTerm: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        searchTerm: 'search-term',
      },
    }
  )
}
